import React, { Fragment, useState } from 'react'
import {Modal, Backdrop, Fade} from '@material-ui/core'
import {makeStyles} from '@material-ui/styles'
import { SignalWifi1BarLock } from '@material-ui/icons';

import '../../Css/VerificationModals.scss'

const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    
  }));

const SimpleModal = (props) => {
    const modalStyle = useStyles()
    const [Open, setOpen] = useState(true)

    return (
        <Fragment>
            <Modal
                 
                 className={modalStyle.modal}
                 open={true}
                 onClose= {props.onClose}
                 closeAfterTransition
                 BackdropComponent={Backdrop}
                 BackdropProps={{
                   timeout: 500,
                 }}
            >
                
                <Fade in={Open}>
                    <div className="modalWrapper">
                        <div className = "modalHeader">
                          {props.headerMessage}
                        </div>
                        <div className = "modalBody">
                         {props.bodyMessage}
                        </div>
                        <div className = "modalFooter">
                          <div className = "buttonWrapper">
                              <button
                                onClick = {props.button}
                              >
                                {props.buttonName}
                              </button>
                          </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
            
        </Fragment>
    )
}

export default SimpleModal;